/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type DistributionByDateAreaChart_question = {|
  +type: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DistributionByDateAreaChart_question",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Question"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/DistributionByDateAreaChart/__generated__/DistributionByDateAreaChart_question.graphql.js